module.exports = __webpack_public_path__ + "img/us.2382ea7e.svg";